// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__6OgcK","additionalInfo":"AgreementModal_additionalInfo__btFNh"};